/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SearchMetadata } from './SearchMetadata';

export type KnowledgeSearchResult = {
    search_item_type?: string;
    id: string;
    kind: KnowledgeSearchResult.kind;
    title: string;
    url: string;
    external: boolean;
    icon?: (string | null);
    excerpt?: (string | null);
    updated_on?: (string | null);
    search_metadata: SearchMetadata;
};

export namespace KnowledgeSearchResult {

    export enum kind {
        ARTICLE = 'article',
        LINK = 'link',
    }


}

